import { Box } from '@material-ui/core';
import classNames from 'classnames';
import { SGSForm, SGSFormDate, SGSRadioCtr } from 'components';
import { formHasField } from 'features/arretTravail/models/scenarii';
import { ouiNonOptions } from 'features/arretTravail/models/StopInformation/workStoppage';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../../../../css/ArretTravail.module.scss';

type AccidentDateSectionProps = {
    store: any;
};

export const Accident: React.FC<AccidentDateSectionProps> = ({ store }) => {
    const { watch } = useFormContext();

    // Cerfa S6202
    const hasAccidentDate = formHasField(['workStoppage.infos.accidentDate'], 'formAtFields', store);
    const hasOtherVictime = formHasField(['workStoppage.infos.hasOtherVictims'], 'formAtFields', store);
    const watchLastDayWorked = watch('workStoppage.infos.lastDayWorked');

    if (!hasAccidentDate || !hasOtherVictime) {
        if (!hasAccidentDate) delete store?.workStoppage?.infos?.accidentDate;
        if (!hasOtherVictime) delete store?.workStoppage?.infos?.hasOtherVictime;
        return null;
    }

    return (
        <>
            {(hasAccidentDate || hasOtherVictime) && <Box className={classNames(styles.title, 'mb-4')}>Accident :</Box>}
            {hasAccidentDate && (
                <SGSForm.Row>
                    <SGSForm.Col md={6}>
                        <SGSFormDate inputVariant="outlined" name="workStoppage.infos.accidentDate" label="workStop.fields.workStoppage.infos.accidentDate" maxDate={watchLastDayWorked} />
                    </SGSForm.Col>
                </SGSForm.Row>
            )}
            {hasOtherVictime && (
                <SGSForm.Row>
                    <SGSForm.Col md={12}>
                        <SGSRadioCtr row options={ouiNonOptions} name="workStoppage.infos.hasOtherVictims" label="workStop.fields.workStoppage.infos.hasOtherVictims" />
                    </SGSForm.Col>
                </SGSForm.Row>
            )}
        </>
    );
};

export default Accident;
